import backgroundImg from './background/background.png';
import background2Img from './background/background2.png';
import cloudSvg from './clouds/cloud.svg';
import beamsPng from './sun_beams/beams.png';

export const ATMOSPHERE_BACKGROUND_URLS = {
  welcome: backgroundImg,
  delivery: background2Img,
} as const;

export const ATMOSPHERE_CLOUD_SVG_URL = cloudSvg;
export const ATMOSPHERE_SUN_BEAMS_URL = beamsPng;

export function getAtmosphereAssetUrls(): string[] {
  return [
    ATMOSPHERE_BACKGROUND_URLS.welcome,
    ATMOSPHERE_BACKGROUND_URLS.delivery,
    ATMOSPHERE_CLOUD_SVG_URL,
    ATMOSPHERE_SUN_BEAMS_URL,
  ];
}
